import classNames from "classnames";
import { FC, useContext } from "react";
import { useRouter } from "next/router";
import ToggleOpenSidebarIcon from "@svg/access/sidebar/ToggleOpenSidebar";
import { toFarsiNumber } from "@utils/digits";
import AngleIcon from "@svg/angle-icon";
import { AccessContext } from "@templates/course/context";
import { COURSE_TYPE } from "@types";
import TextLessonSkeleton from "./text-lesson-skeleton";

const randomWidthGenerator = () => Math.floor(Math.random() * 80) + 60;

const AccessSkeleton: FC = () => {
  const { pathname } = useRouter();
  const { courseData } = useContext(AccessContext);

  const isTextCourse =
    pathname === "/texts/[slug]" ||
    courseData?.product?.attribute_type === COURSE_TYPE.TEXT;

  return (
    <div className="bg-fds-on-inverse relative">
      <div className="relative z-0">
        <div className="mx-auto w-full">
          <div className="flex items-center w-full px-6 bg-fds-on-inverse shadow-sm topbar-navigation-sizing">
            <div className="h-4 w-1/3 bg-fds-tertiary-select animate-pulse rounded-4" />
          </div>
          <div className="flex w-full relative">
            <div className="md:grow w-full">
              {isTextCourse ? (
                <TextLessonSkeleton />
              ) : (
                <div className="md:mx-0">
                  <div className="relative bg-fds-always-black flex justify-center items-start video-player-sizing overflow-hidden">
                    <div className="h-full aspect-video object-cover bg-[#e6e6e6] animate-pulse" />
                  </div>
                </div>
              )}
            </div>
            <div
              className="hidden lg:flex sticky duration-500 flex-col transition-[transform,width,min-width,max-width] translate-x-0 access-sidebar-open-styles"
              style={{ height: "100dvh" }}
            >
              <div className="flex items-center w-full bg-fds-brand-light">
                <div className="w-8 h-12 absolute py-3  px-1 rounded-r-10 text-fds-secondary bg-fds-brand-light -right-4 cursor-pointer">
                  <ToggleOpenSidebarIcon />
                </div>
                <div className="w-full overflow-hidden">
                  <div className="py-4     px-5">
                    <div className="flex items-center justify-between w-full mb-3">
                      <div className="flex items-center gap-2">
                        <p className="font-semibold text-fds-secondary">
                          سرفصل‌ها
                        </p>
                        <div className="h-3 w-px bg-lightDivider" />
                        <div className="h-3 w-14 bg-fds-placeholder animate-pulse rounded-2" />
                      </div>
                      <div>
                        <div className="h-3 w-12 bg-fds-placeholder animate-pulse rounded-4" />
                      </div>
                    </div>
                    <div className="w-full h-1 rounded-2 bg-fds-on-inverse flex justify-start" />
                  </div>
                </div>
              </div>
              <div className="bg-fds-on-inverse border border-fds-default grow overflow-y-auto">
                <div className="relative overflow-x-hidden rounded-b-10 pb-6  h-full">
                  {Array(12)
                    .fill("")
                    .map((_i, index) => (
                      <div
                        key={index}
                        className={classNames(
                          "flex items-center justify-between py-4 pr-4 pl-2",
                          index === 0 ? " border-t border-white" : ""
                        )}
                      >
                        <div className="flex gap-2">
                          <p className="font-medium">
                            {toFarsiNumber(String(index + 1))}.
                          </p>
                          <div
                            className="h-4 bg-fds-tertiary-select animate-pulse rounded-4"
                            style={{
                              width: `${randomWidthGenerator()}px`,
                            }}
                          />
                        </div>
                        <AngleIcon className="ml-2 flex-shrink-0 transition-transform" />
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessSkeleton;
